const color = {
   black: '#000000',
   white: '#ffffff',
   green: '#75D3A8',
   aqua: '#00A4A7',
   violet: '#31273E',
   yellow: '#FFD740',
   red: '#E31B0C',
   orange: '#FFB300',
   grayLight: '#ACA9B2',
   grayDark: '#837E8B',
   blue: '#00A3FF',
}

export default color
